import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getDisciplinas = async () => {
    let disciplinas = null;
    try {
        const response = await api.get(`Disciplina/listcontroller`, config);
        disciplinas = response.data.data;
    } catch (err) {}
    return disciplinas;
}